/**
 * Locale configuration. Language is a client-side choice (no URL prefix):
 * it lives in a React context, is persisted to localStorage (`cate:lang`),
 * and is reflected on `<html lang>`. See `context.tsx`.
 */

export const LOCALES = ["en", "zh", "es"] as const;

export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "en";

/** Native language names, shown in the language switcher menu. */
export const LOCALE_NAMES: Record<Locale, string> = {
  en: "English",
  zh: "中文",
  es: "Español",
};

/** Compact labels for the collapsed switcher button. */
export const LOCALE_SHORT: Record<Locale, string> = {
  en: "EN",
  zh: "中",
  es: "ES",
};

export function isLocale(value: unknown): value is Locale {
  return typeof value === "string" && (LOCALES as readonly string[]).includes(value);
}
